import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { redirectToExternalUrl, setPathForReEntryRedirect } from 'helpers/RouteHelper';
import Style from './UnlockUpsell.module.scss';

const UnlockUpsell = ({ buttonText = '', children, rendered = false }) => {
  if (!rendered) return null;
  const buttonOnClick = () => {
    const signUpUrl = window?.ExternalConfig?.externalPaymentUrlMonthly;
    handleAnalytics({
      event: Events.PURCHASE_CTA_CLICKED,
      payload: {
        page_item_title: buttonText,
        page_item_subtitle: '',
        page_action_location: 'uspell',
        page_button_text: buttonText,
      },
    });
    setPathForReEntryRedirect();
    redirectToExternalUrl(signUpUrl);
  };
  const button = (
    <button className={Style.button} onClick={buttonOnClick}>
      {buttonText}
    </button>
  );
  return (
    <div className={Style.container}>
      <div className={Style.imageContainer}>
        <Image source="/static/images/foxnation-freemium-background.png" className={Style.image} />
      </div>
      <div className={Style.content}>
        {children}
        {button}
      </div>
    </div>
  );
};

UnlockUpsell.propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  rendered: PropTypes.bool,
};

export default UnlockUpsell;
